<template>
  <div class="order" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="orderState">
      <div class="meeting">
        <div class="meetingName">
          <div class="blankTwo"></div>
          <div class="nameText">{{ this.meetingName }}</div>
          <div class="button">
            <div class="orderButton" @click="orderHandle" v-if="apkStatus">
              <div class="orderText">预约</div>
            </div>
            <!-- <div class="signButton" @click="signHandle" v-if="showSign">
                                <div class="signText">签到</div>
                            </div> -->
          </div>
        </div>
      </div>
      <div class="meetingList">
        <img :src="adImg" alt="" v-if="imgShow" />
        <video autoplay muted controls loop="loop" v-if="videoShow">
          <source :src="adVideo" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { allLists, getMeetModel, releases } from "@/utils/request";
import HomeHeader from "./header";
export default {
  components: {
    HomeHeader
  },
  data() {
    return {
      clocktimer: null,
      meetStatus: "", //会议状态 1正在使用  3未使用
      equipmentName: "",
      meetingName: "",
      meetingId: "",
      fonts: "",
      startTime: "",
      showSign: "",
      dataList: [],
      adImg: "",
      adVideo: "../assets/1.mp4",
      sourceType: "",
      imgShow: false,
      videoShow: false,
      bgUrl:'',
      apkStatus: ''
    };
  },
  mounted() {
    this.bgUrl = localStorage.getItem('bgUrl')
    this.apkStatus = localStorage.getItem('apkStatus') === '1' ? true:false
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.releases();
    if (this.clocktimer) {
      clearInterval(this.clocktimer);
    } else {
      this.clocktimer = setInterval(() => {
        this.allLists();
        // this.getMeetModels();
      }, 30000);
    }
  },
  beforeDestroy() {
    if (this.clocktimer) {
      clearInterval(this.clocktimer);
    }
  },
  methods: {
    getMeetModels() {
      getMeetModel().then(res => {
        if (Number(res.code) === 0) {
          this.fonts = res.data.fontStyle;
        }
      });
    },
    // 会议室信息列表
    allLists() {
      let params = {
        meetingId: this.meetingId
      };
      allLists(params).then(res => {
        if (res.code == 0) {
          this.meetStatus = res.data.status[0].meetStatus;
          this.flag = res.data.flag;
          if (res.data.pageInfoList.list.length > 0) {
            this.showSign = true;
            this.dataList = res.data.pageInfoList.list;
            this.startTime = res.data.pageInfoList.list[0].startTime;
          } else {
            this.showSign = false;
          }
          if (this.meetStatus == 3 && res.data.pageInfoList.list.length > 0) {
            const curdatetime = new Date().getTime();
            const curstarttime = new Date(this.startTime).getTime();
            if (curstarttime - curdatetime < 30 * 60 * 1000) {
              this.$router.push({
                path: "/homepage",
                query: {
                  equipmentName: this.equipmentName,
                  meetingId: this.meetingId,
                  meetingName: this.meetingName
                }
              });
            }
          }
        }
      });
    },
    // 点击跳转
    orderHandle() {
      this.$router.push({
        path: "/appoint",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          meetingName: this.meetingName
        }
      });
    },
    // 广告信息
    releases() {
      let params = {
        meetingId: this.meetingId
      };
      releases(params).then(res => {
        console.log(res);
        if (res.code == 0 && res.data.length > 0) {
          // this.content = res.data[0].content
          // this.theme = res.data[0].theme
          this.sourceType = res.data[0].sourceType;
          this.typeOne = res.data[0].typeOne;
          this.adImg = res.data[0].url;
          this.adVideo = res.data[0].url;
          if (this.sourceType == 3 && this.typeOne == 1) {
            this.imgShow = false;
            this.videoShow = true;
          }
          if (this.sourceType == 3 && this.typeOne == 2) {
            this.videoShow = false;
            this.imgShow = true;
          }
        }
      });
    },
    changeF(font) {
      this.fonts = font;
    }
    // signHandle () {
    //     localStorage.setItem('isAuto','no')
    //     this.$router.push({path: '/register', query: {equipmentName: this.equipmentName, meetingId: this.meetingId, meetingName:this.name, id: this.id, theme:this.theme, startTime: this.startTime, endTime: this.endTime}})
    // }
  }
};
</script>

<style lang="less" scoped>
.order {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .orderState {
    width: 100%;
    height: 90%;
    display: flex;
    .meeting {
      width: 50%;
      height: 85%;
      display: flex;
      .meetingName {
        width: 100%;
        height: 90%;
        .blankTwo {
          width: 100%;
          height: 32%;
        }
        .nameText {
          width: 100%;
          // min-height: 42%;
          font-size: 110px;
          line-height: 1;
          color: #fff;
          text-align: center;
          letter-spacing: 19px;
        }
        .button {
          width: 60%;
          height: 50%;
          display: flex;
          margin: 0 auto;
          .orderButton {
            width: 100%;
            height: 100%;
            background: url(../assets/qiandao.png) no-repeat;
            background-position: center center;
            // position: relative;
            // left: 9%;
            .orderText {
              // width: 60%;
              // text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              font-size: 49px;
              font-family: SimHei;
              font-weight: bold;
              color: #ffffff;
              background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              line-height: 168px;
            }
          }
          .signButton {
            width: 100%;
            height: 100%;
            background: url(../assets/qiandao.png) no-repeat;
            background-position: center center;
            // position: relative;
            // left: 9%;
            .signText {
              // width: 60%;
              // text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              font-size: 49px;
              font-family: SimHei;
              font-weight: bold;
              color: #ffffff;
              background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              line-height: 168px;
            }
          }
        }
      }
    }
    .meetingList {
      width: 50%;
      video {
        width: 100%;
        height: 100%;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/canBusiness.vue